import { useMediaQuery, useTheme } from '@mui/material';

export const useTabletLayoutAndUp = () => {
  const theme = useTheme();

  return useMediaQuery(theme.breakpoints.up('sm'), {
    noSsr: true,
  });
};
